/* Product offer state is derived from Shopify allocations, never a guessed discount. */
(() => {
  'use strict';
  const root = document.querySelector('[data-mobility-product]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-wm-product-json]').textContent);
  const form = root.querySelector('[data-wm-form]');
  const add = root.querySelector('[data-wm-add]');
  const error = root.querySelector('[data-wm-error]');
  const select = root.querySelector('[data-wm-selling-plan]');
  const planWrap = root.querySelector('[data-wm-plan-wrap]');
  const subOption = root.querySelector('[data-wm-subscription-option]');
  const sticky = root.querySelector('[data-wm-sticky]');
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency }).format(value / 100);
  const jars = variant => parseInt(variant.title, 10) || 1;
  const plans = variant => variant.plans.filter(plan => {
    const weeks = jars(variant) >= 6 ? 24 : jars(variant) >= 3 ? 12 : 4;
    return new RegExp('every\\s+' + weeks + '\\s+weeks', 'i').test(plan.name);
  });
  const variant = () => data.variants.find(item => String(item.id) === form.elements.id.value);
  let busy = false;
  function update(rebuild = false) {
    const current = variant();
    if (!current) return;
    const availablePlans = plans(current);
    if (subOption) {
      subOption.hidden = !availablePlans.length;
      subOption.querySelector('input').disabled = !availablePlans.length;
    }
    if (!availablePlans.length) form.querySelector('[value="one-time"]').checked = true;
    if (rebuild) {
      select.replaceChildren(...availablePlans.map(plan => new Option(plan.name, plan.id)));
    }
    const subscribed = form.elements.purchase_type.value === 'subscription';
    select.disabled = !subscribed;
    planWrap.hidden = !subscribed;
    const selectedPlan = availablePlans.find(plan => String(plan.id) === select.value) || availablePlans[0];
    const price = subscribed && selectedPlan ? selectedPlan.price : current.price;
    root.querySelector('[data-wm-onetime-price]').textContent = money(current.price);
    if (availablePlans.length) {
      root.querySelector('[data-wm-sub-price]').textContent = money(selectedPlan.price);
      const saving = current.price ? Math.round(100 * (1 - selectedPlan.price / current.price)) : 0;
      root.querySelector('[data-wm-sub-saving]').textContent = saving > 0 ? saving + '%' : '';
    }
    for (const item of data.variants) {
      const plan = plans(item)[0];
      const amount = subscribed && plan ? plan.price : item.price;
      root.querySelector('[data-wm-bundle-total="' + item.id + '"]').textContent = money(amount);
      root.querySelector('[data-wm-bundle-unit="' + item.id + '"]').textContent = money(amount / jars(item)) + '/jar';
    }
    root.querySelector('[data-wm-summary]').textContent = subscribed
      ? money(price) + ' per delivery · ' + selectedPlan.name + ' · repeats until canceled.'
      : money(price) + ' total · one-time purchase · no recurring orders.';
    add.disabled = busy || !current.available;
    add.textContent = busy ? 'Adding to cart…' : !current.available ? 'Sold out' : (subscribed ? 'Subscribe' : 'Add to cart') + ' — ' + money(price);
    root.querySelector('[data-wm-sticky-summary]').textContent = jars(current) + (jars(current) === 1 ? ' jar · ' : ' jars · ') + money(price) + (subscribed ? ' / delivery' : '');
    const url = new URL(location.href);
    url.searchParams.set('variant', current.id);
    history.replaceState({}, '', url);
  }
  form.addEventListener('change', event => update(event.target.name === 'id'));
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    const current = variant();
    if (!current?.available) return;
    error.hidden = true;
    const item = { id: current.id, quantity: 1 };
    if (form.elements.purchase_type.value === 'subscription') {
      const plan = plans(current).find(value => String(value.id) === select.value);
      if (!plan) { error.textContent = 'Please select a delivery schedule.'; error.hidden = false; return; }
      item.selling_plan = plan.id;
    }
    busy = true; update();
    try {
      const response = await fetch(window.Wagspan.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'We could not add this item. Please try again.');
      document.dispatchEvent(new CustomEvent('wagspan:cart-refresh', { detail: { opener: add } }));
    } catch (failure) {
      error.textContent = failure.message || 'Please check your connection and try again.';
      error.hidden = false;
    } finally { busy = false; update(); }
  });
  root.querySelectorAll('[data-wm-thumbnail]').forEach(button => {
    button.addEventListener('click', () => {
      const image = button.querySelector('img');
      const main = root.querySelector('[data-wm-main-image]');
      main.src = image.src; main.alt = image.alt;
      root.querySelectorAll('[data-wm-thumbnail]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
  });
  let queued = false;
  function updateSticky() {
    queued = false;
    const rect = add.getBoundingClientRect();
    const outside = rect.bottom < 0 || (window.innerWidth <= 680 && rect.top > window.innerHeight);
    sticky.hidden = !outside || document.querySelector('#CartDrawer.is-open') !== null;
  }
  window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(updateSticky); } }, { passive: true });
  window.addEventListener('resize', updateSticky);
  new MutationObserver(updateSticky).observe(document.querySelector('#CartDrawer'), { attributes: true, attributeFilter: ['class'] });
  update(true); updateSticky();
})();
